import React, { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography';
import HomepageStyles from './Homepage.module.css';
import { Box, Button } from '@mui/material';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import KeyboardArrowUpSharpIcon from '@mui/icons-material/KeyboardArrowUpSharp';
import KeyboardArrowDownSharpIcon from '@mui/icons-material/KeyboardArrowDownSharp';
import { Link } from 'react-router-dom';
import axios from 'axios';
import EditHomeBanner from '../EditHomeBanner/EditHomeBanner';
import Modal from '@mui/material/Modal';

const Homepage = () => {

  const [bannerData, setBannerData] = useState();
  const [busniessData, setBusniessData] = useState();
  const [teamData, setTeamData] = useState();
  const [businessLatestDate, setBusinessLatestDate] = useState(null);
  const [teamLatestDate, setTeamLatestDate] = useState(null);




  const getAllBannerData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_COSMOSADMIN}/bannerVideo/getAllBannerDetails`);
      setBannerData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllBannerData()
  }, [])


  // ------------------------------------------------------------------------------------------------------


  const getAllBusinessData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_COSMOSADMIN}/business/getAllBusinessDetails`
      )
      setBusniessData(res.data)

      const dates = res.data.map((item) => {
        const [day, month, year] = item.business.date.split('.');
        return (
          new Date(year, month - 1, day).getTime()
        )
      });
      const maxDate = new Date(Math.max(...dates));
      setBusinessLatestDate(maxDate);
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getAllBusinessData()
  }, [])

  // ------------------------------------------------------------------------------------------------------

  const formatDate = (date) => {
    return date ? new Date(date).toLocaleDateString('en-GB', { day: 'numeric', month: 'numeric', year: 'numeric' }).replace(/\//g, '.') : '';
  };


  const getAllTeamData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_COSMOSADMIN}/team/getAllTeamDetails`
      )
      setTeamData(res.data)
      const dates = res.data.map((item) => {
        const [day, month, year] = item.team.date.split('.');
        return (
          new Date(year, month - 1, day).getTime()
        )
      });
      const maxDate = new Date(Math.max(...dates));

      setTeamLatestDate(maxDate);
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    getAllTeamData()
  }, [])


  return (
    <div className={HomepageStyles.homepageMain}>
      <div className={HomepageStyles.homepageContent}>
        <Typography sx={{ marginTop: '2%', color: '#121926', fontWeight: '600', fontSize: '20px', paddingBottom: '3%' }} >
          Homepage
        </Typography>
        <Box className={HomepageStyles.homepageComponent}>
          <div className={HomepageStyles.homepageComponentLeft}>
            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
              Title
            </Typography>
          </div>
          <div className={HomepageStyles.homepageComponentRight}>
            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
              Last modified
            </Typography>
            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
              Action
            </Typography>
          </div>
        </Box>
        <Box className={HomepageStyles.homepageComponent}>
          <div className={HomepageStyles.homepageComponentLeft}>
            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
              Hero Banner
            </Typography>
          </div>
          <div className={HomepageStyles.homepageComponentRight}>
            <Typography variant='h6' sx={{ fontSize: '15px' }}>
              {formatDate(bannerData?.[0]?.date)}
            </Typography>
            <span style={{ fontSize: '15px', fontWeight: '600' }}>
              <Link to='/homebanner' >
                <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
              </Link>
            </span>

          </div>
        </Box>
        <Box className={HomepageStyles.homepageComponent}>
          <div className={HomepageStyles.homepageComponentLeft}>
            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
              Our Business
            </Typography>
          </div>


          <div className={HomepageStyles.homepageComponentRight}>
            <Typography variant='h6' sx={{ fontSize: '15px' }}>
              {formatDate(businessLatestDate)}
            </Typography>
            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
              <Link to='/ourbusiness'>
                <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
              </Link>
            </Typography>
          </div>
        </Box>
        <Box className={HomepageStyles.homepageComponent}>
          <div className={HomepageStyles.homepageComponentLeft}>
            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
              Meet our Team
            </Typography>
          </div>
          <div className={HomepageStyles.homepageComponentRight}>
            <Typography variant='h6' sx={{ fontSize: '15px' }}>
              {formatDate(teamLatestDate)}
            </Typography>
            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
              <Link to='/meetourteam'>
                <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
              </Link>
            </Typography>
          </div>
        </Box>
      </div>


    </div>
  )
}

export default Homepage